import React, { Component } from 'react'
import { Card, WhiteSpace, WingBlank, List, Toast } from 'antd-mobile'
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import debounce from 'lodash/debounce'
import { getBlogs } from '../actions/queries'
import './styles/overwrite.css'

const Item = List.Item

const FourToTenBg = {
  position: 'absolute',
  width: '38px',
  height: '14px',
  left: '-2px',
  paddingTop: '34px',
}
const patientMale = require('./images/patient-male.png')
const zan1 = require('./springImage/zan1.png')
const zan2 = require('./springImage/zan2.png')

class Comment extends Component {
  state = {
    content: [],
    commentVoteState: [],
    myQuestion: {},
    myKey: null,
    maxKey: 4,
    showAllQuestion: false,
  }
  componentWillReceiveProps(props) {
    const theme = get(props, 'theme.theme.themes')
    if (!props.theme.loading) {
      const themeTwo = theme[1]
      const patientId = get(this.props, 'match.params.patientId')
      const comments = themeTwo.comments
      const contentArray = []
      let commentVoteState = {}
      let myQuestion = {}
      let myKey = null
      let showAllQuestion = true
      if (comments.length > 4) showAllQuestion = false

      for (const key in comments) {
        if (comments.hasOwnProperty(key)) {
          const comment = comments[key]
          if (comment.user._id === patientId) {
            myQuestion = comment
            myKey = key
          }
          if (comment.votes.indexOf(patientId) > -1) {
            commentVoteState[key] = [true, comment.votes.length]
          } else {
            commentVoteState[key] = [false, comment.votes.length]
          }
          if (comment.content.split('').length > 70) {
            contentArray.push({
              content: comment.content,
              isHide: true,
            })
          } else {
            contentArray.push({
              content: comment.content,
              isHide: false,
            })
          }
        }
      }
      this.setState({
        commentVoteState: commentVoteState,
        content: contentArray,
        myQuestion,
        myKey,
        showAllQuestion,
      })
    }
  }
  onShowAllButtonClick = () => {
    const theme = get(this.props, 'theme.theme.themes')
    const length = theme[1].comments.length
    const oldLength = this.state.maxKey
    if (oldLength + 5 < length) {
      this.setState({ maxKey: oldLength + 5 })
    } else {
       this.setState({ showAllQuestion: true, maxKey: oldLength + 5 })
    }
  }
  commentVotesClick = (key, action, commentId, ifMyQuestion) => {
    let commentVoteState = this.state.commentVoteState
    const patientId = get(this.props, 'match.params.patientId')
    const myQuestion = cloneDeep(this.state.myQuestion)
    if (ifMyQuestion) {
      myQuestion.votes.push(patientId)
    } else if (this.state.myKey && this.state.myKey === key) {
      myQuestion.votes.push(patientId)
    }
    if (action === 'add') {
      commentVoteState[key] = [
        !commentVoteState[key][0],
        commentVoteState[key][1] + 1,
      ]
    } else {
      commentVoteState[key] = [
        !commentVoteState[key][0],
        commentVoteState[key][1] - 1,
      ]
    }
    this.setState({ commentVoteState, myQuestion })
    this.handleVotesClick(key, action, commentId)
  }
  onHideButtonClick = (key, content) => {
    console.log('click', key, content)
    const newContent = this.state.content
    if (newContent[key].isHide) {
      newContent[key].isHide = !newContent[key].isHide
      newContent[key].content = content
    } else {
      newContent[key].isHide = !newContent[key].isHide
      newContent[key].content = content
    }
    this.setState({ content: newContent })
  }
  handleVotesClick = debounce((key, action, commentId) => {
    const mutate = this.props.updateThemeVote
    const theme = get(this.props, 'theme.theme')
    const themeId = theme._id

    const type = 'voteComment'
    const patientId = get(this.props, 'match.params.patientId')
    const systemType = get(this.props, 'match.params.systemType', 'BG')
    const variables = {
      themeId,
      systemType,
      type,
      patientId,
      commentId,
    }
    console.log('variables', variables)
    mutate({
      variables,
    })
      .then(res => {
        console.log('mutate then', res)
      })
      .catch(e => {
        console.log('catch a error', e)
      })
  }, 1500)

  render() {
    const theme = get(this.props, 'theme.theme.themes')
    if (!this.props.theme.loading) {
      const themeTwo = theme[1]
      const comments = themeTwo.comments
      const patientId = get(this.props, 'match.params.patientId')
      const isShare = get(this.props, 'isShare', true)
      const commentElement = []

      if (this.state.myQuestion && this.state.myQuestion._id) {
        commentElement.push(
          <Item
            key={'itemmy'}
            style={{ backgroundColor: 'rgba(255,88,76,0.1)', color: '#584F62' }}
          >
            <div className="comment-list">

                <div
                  className="head-image"
                  style={{
                    float: 'left',
                    width: '40px',
                    textAlign: 'center',
                    backgroundImage:
                      'url(' + require('./springImage/me.png') + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                  }}
                >
                  <img
                    style={{
                      width: '32px',
                      height: '32px',
                      paddingLeft: '4px',
                      borderRadius: '50%',
                      paddingTop:'5px'
                    }}
                    src={this.state.myQuestion.user.avatar ? this.state.myQuestion.user.avatar.replace(/http:/,'https:') : patientMale}
                  />
                </div>
                <div
                  className="comment-content"
                >
                  <div style={{ position: 'relative', zIndex: 1}}>
                    <div
                      style={{
                        float: 'left',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '16px',
                          fontWeight: '500',
                        }}
                      >
                        我
                      </div>
                      <div
                        style={{
                          fontSize: '10px',
                          color: '#584F62',
                        }}
                      >
                        {moment(this.state.myQuestion.createdAt).format(
                          'MM-DD HH:mm'
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        float: 'right',
                      }}
                    >
                      {(() => {
                        if (
                          this.state.myQuestion.votes.indexOf(patientId) > -1
                        ) {
                          return (
                            <div>
                              <img
                                src={require('./springImage/zan1.png')}
                                style={{
                                  width: '14px',
                                  height: '14px',
                                }}
                              />
                              <span
                                style={{
                                  marginLeft: '8px',
                                    minWidth: '30px',
                                    display: 'inline-block',
                                    textAlign: 'right'
                                }}
                              >
                                {this.state.myQuestion.votes.length}
                              </span>
                            </div>
                          )
                        } else {
                          return (
                            <div
                              onClick={() => {
                                isShare
                                  ? () => {}
                                  : this.commentVotesClick(
                                      this.state.myKey,
                                      'add',
                                      this.state.myQuestion._id,
                                      true
                                    )
                              }}
                            >
                              <img
                                src={require('./springImage/zan2.png')}
                                style={{
                                  width: '14px',
                                  height: '14px',
                                }}
                              />
                              <span
                                style={{
                                  marginLeft: '8px',
                                    minWidth: '30px',
                                    display: 'inline-block',
                                    textAlign: 'right'
                                }}
                              >
                                {this.state.myQuestion.votes.length}
                              </span>
                            </div>
                          )
                        }
                      })()}
                    </div>
                    <div
                      className="comment-text"
                      style={{
                        float: 'left',
                        fontSize: '12px',
                        color: 'RGBA(88, 79, 98, 1)',
                        width: '100%',
                      }}
                    >
                    {this.state.content[this.state.myKey].isHide
                          ?
                          <div>
                            <div className="overlength-comment" style={{webkitBoxOrient: 'vertical', webkitLineClamp: '3'}}>{this.state.myQuestion.content}</div>
                            <div
                              className="hide-question-item"
                              onClick={() => {
                                this.onHideButtonClick(this.state.myKey, this.state.myQuestion.content)
                              }}
                            >
                              点击这里查看全部
                            </div>
                          </div>
                          : this.state.myQuestion.content
                      }

                    </div>
                  </div>
                  <img
                          src={require('./springImage/me_logo.png')}
                          style={{
                              width: '30pt',
                              height: '30pt',
                              position: 'absolute',
                              bottom: '1px',
                              right: '5px'
                              }}
                      />
                </div>

            </div>
          </Item>
        )
      }
      for (const key in comments) {
        if (key < this.state.maxKey && comments.hasOwnProperty(key)) {
          const c = comments[key]
          commentElement.push(
            <Item key={'item' + key}>
              <div className="comment-list">
                  <div
                    className={`head-image${key>2?' gt3':''}` }
                  >
                    <img className="avatar" src={c.user.avatar ? c.user.avatar.replace(/http:/,'https:') : patientMale}/>

                    {key < 10 ? (
                      <img
                        className="bg"
                        src={require(`./springImage/di${parseInt(key) +
                          1}ming.png`)}
                      />
                    ) : <p>{parseInt(key) +1}</p>}
                  </div>
                  <div
                    className="comment-content"
                  >
                    <div className="comment-title">
                      <div
                        style={{
                          float: 'left',
                        }}
                      >
                        <div
                          style={{
                            fontWeight: '500',
                            fontSize: '14px',
                          }}
                        >
                          {c.user.nickname}
                        </div>
                        <div
                          style={{
                            fontSize: '10px',
                            color: 'RGBA(180, 177, 185, 1)',
                          }}
                        >
                          {moment(c.createdAt).format('MM-DD HH:mm')}
                        </div>
                      </div>
                      <div
                        style={{
                          float: 'right',
                        }}
                      >
                        {(() => {
                          if (this.state.commentVoteState[key][0]) {
                            return (
                              <div>
                                <img
                                  src={zan1}
                                  style={{
                                    width: '14px',
                                    height: '14px',
                                  }}
                                />
                                <span
                                  style={{
                                    marginLeft: '8px',
                                    minWidth: '30px',
                                    display: 'inline-block',
                                    textAlign: 'right'
                                  }}
                                >
                                  {this.state.commentVoteState[key][1]}
                                </span>
                              </div>
                            )
                          } else {
                            return (
                              <div
                                onClick={() => {
                                  isShare
                                    ? () => {}
                                    : this.commentVotesClick(key, 'add', c._id)
                                }}
                              >
                                <img
                                  src={zan2}
                                  style={{
                                    width: '14px',
                                    height: '14px',
                                  }}
                                />
                                <span
                                  style={{
                                    marginLeft: '8px',
                                    minWidth: '30px',
                                    display: 'inline-block',
                                    textAlign: 'right'
                                  }}
                                >
                                  {this.state.commentVoteState[key][1]}
                                </span>
                              </div>
                            )
                          }
                        })()}
                      </div>
                      <div
                        className="comment-text "
                        style={{
                          float: 'left',
                          fontSize: '12px',
                          color: 'RGBA(88, 79, 98, 1)',
                          width: '100%',
                        }}
                      >{this.state.content[key].isHide
                          ?
                          <div>
                            <div className="overlength-comment" style={{webkitBoxOrient: 'vertical', webkitLineClamp: '3'}}>{c.content}</div>
                            <div
                             className="hide-question-item"
                              onClick={() => {
                                this.onHideButtonClick(key, c.content)
                              }}
                            >
                              点击这里查看全部
                            </div>
                          </div>
                          : c.content}
                      </div>
                    </div>
                  </div>
              </div>
            </Item>
          )
        }
      }

      return (
        <main>
          <Card full>
            <Card.Body>
              <div>
                <div className="theme-title">
                  <h3 style={{ textAlign: 'center' }}>问题排行榜</h3>
                </div>
                <div style={{ textAlign: 'center', color: '#FF584C' }}>
                  <h3 style={{ marginTop: '0px'  }}>{`(共收到${comments.length}条问题)`}</h3>
                </div>
                <List className="comment-list">{commentElement}</List>
                {
                  comments.length > 4 && !this.state.showAllQuestion ?
                  <div
                    className="hide-question-list"
                    onClick={this.onShowAllButtonClick}
                  >点击加载更多问题</div> : <div
                    className="finish-question-list"
                  >已经全部加载完毕</div>
                }
              </div>
            </Card.Body>
          </Card>
        </main>
      )
    } else {
      return <div />
    }
  }
}

export default Comment



// WEBPACK FOOTER //
// ./src/modules/theme/components/springComment.js